/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const TaskStatus = {
  INACTIVE: 'INACTIVE',
  OPEN: 'OPEN',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED'
}

export const TaskType = {
  USER_REJECTED_TASK: 'USER_REJECTED_TASK',
  USER: 'USER'
}
